
import { of as observableOf,  Subject } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { ConfigService } from './../../services/config.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessUnit } from '../../models/identity';
import { BusinessUnitService } from '../../services/business-unit.service';
import { UserService } from '../../services/user.service';
import { ProcessParticipation } from '../../models/process-models';
import { ProcessParticipationService } from '../../services/process.participation.service';

@Component({
  selector: 'app-respondents-approval-business-unit-search-page',
  templateUrl: './respondents-approval-business-unit-search-page.component.html',
  styleUrls: ['./respondents-approval-business-unit-search-page.component.scss']
})
export class RespondentsApprovalBusinessUnitSearchPageComponent implements OnInit {
  searchPattern$ = new Subject<string>();
  selectionType: number;
  processAppraiseeDurationId: number;
  businessUnits: Array<BusinessUnit> = [];
  term: any;
  
  constructor(private readonly route: ActivatedRoute, private readonly configService: ConfigService,
     private readonly router: Router, private buService: BusinessUnitService,
     private readonly userService: UserService, private readonly ref: ChangeDetectorRef,
    private readonly processParticipationService: ProcessParticipationService) { }

  ngOnInit() {
    this.selectionType = +this.route.snapshot.paramMap.get('selectionType');
    this.processAppraiseeDurationId = +this.route.snapshot.paramMap.get('id');
    this.searchBU();
  }

  addRespondentByBU(businessUnit: BusinessUnit) {
    this.userService.getByBusinessUnitId(businessUnit.id).pipe(
    switchMap(x => {
      const processParticipation: ProcessParticipation = {
        respondents: x,
        processDurationAppraiseeId: this.processAppraiseeDurationId
      };
      return this.processParticipationService.addBURespondentsToApprove(processParticipation);
    }))
    .subscribe(x => {
      this.businessUnits = this.updateBusinessUnits(businessUnit.id);
    });
    
  }

  emitSearchPattern(searchPattern: any) {
    this.searchPattern$.next(searchPattern);
  }

  return() {
    this.router.navigate([`${this.route.snapshot.parent.routeConfig.path}/confirmations-bu-detail/${this.processAppraiseeDurationId}`,
     {requirementType: this.route.snapshot.paramMap.get('requirementType')}]);
  }

  private searchBU() {
    this.searchPattern$.pipe(
      debounceTime(this.configService.configData.searchPersonDebounceTime),
      switchMap(term => {
        if (term.length <= this.configService.configData.minimumSearchStringLength) {
          return observableOf();
        }
        return this.buService.getBusinessUnitInfo(term);
      }))
      .subscribe(x => {
        this.businessUnits = x as Array<BusinessUnit>;

        this.ref.detectChanges();
      });
  }
  

  private updateBusinessUnits(businessUnitId: number): Array<BusinessUnit> {
    return this.businessUnits.filter(x => x.id !== businessUnitId);
  }
}
